import apiClient from './apiClient';

export interface User {
  User_ID: string;
  firstname: string;
  lastname: string;
  mail: string;
  picture: string;
  jobtitle?: string;
  profile?: string;
  linkedin?: string;
  gender?: string;
  roles?: Array<string>; // Made optional since roles are now at the top level in the API response
}

export async function getSession() {
  try {
    const response = await apiClient.get('/api/v2/web/auth/session');
    
    console.log('Session response status:', response.status);
    console.log('Session response headers:', response.headers);
    console.log('Session data:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('Session fetch error:', error);
    return { authenticated: false };
  }
}



export async function loginWithMicrosoft(token: string) {
  const forward_url = sessionStorage.getItem('redirectAfterLogin') || '/';

  try {
    console.log('Sending token to backend API...');
    
    const response = await apiClient.post('/api/v2/web/auth/microsoft', {
      access_token: token,
      forward_url
    }, {
      maxRedirects: 0, // Don't follow redirects automatically
      validateStatus: (status) => status >= 200 && status < 400 // Accept 2xx and 3xx as valid
    });
    
    console.log('Backend authentication response status:', response.status);
    console.log('Backend authentication response data:', response.data);
    
    // Check for successful authentication
    if (response.status === 200 || response.status === 302) {
      return response.data || { 
        authenticated: true,
        redirectUrl: response.headers['location'] || forward_url
      };
    }
    
    return { authenticated: false };
  } catch (error) {
    console.error('Microsoft login API error:', error);
    throw error; // Re-throw to allow handling in the component
  }
}

export async function logout() {
  try {
    await apiClient.get('/api/v2/web/auth/logout');
    
    return true;
  } catch (error) {
    console.error('Logout fetch error:', error);
    return false;
  }
}